import React, {Component } from 'react';
import { connect } from "react-redux";
import { setLoader } from "../../redux/actions";
import {
  Button,
  ModalHeader,
  ModalBody
} from "reactstrap";
import FormSmart from './FormSmart';
import { NotificationManager } from "../../components/common/react-notifications";
import AppLocale from "../../config/lang";
import _axios from '../../libs/axios';
import CustomModal from './CustomModal';

class ImportTo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      formFields: [],
      formButtons: []
    }

    this.M = `${this.props.moduleName}.`
  }

  UNSAFE_componentWillMount() {
    this.createForm()
  }

  componentDidMount() {
    if (this.props.ctxImportTo) this.props.ctxImportTo(this)
  }

  componentDidUpdate(prevProps, prevState) {
  }

  componentWillUnmount() {
  }

  createForm = () => {
    let fields = [
      {
        col: 12,
        name: "label1",
        value: `${this.M}importNote`,
        type: "label",
      },
      {
        col: 12,
        name: "btnTemplate",
        type: "button",
        label: "main.downloadExcelTemplate",
        onClick: () => {
          window.open(`${window.tenant.url}tplmails/dwn/${this.props.templateFile}`, "_blank")
        }
      },
      {
        col: 12,
        name: "csvfile",
        value: "",
        type: "dropzone",
        rules: "required",
        placeholder: "main.selectFile",
        opts: {
          accept: '.csv',
          output: true
        }
      }
    ]

    let buttons = [
      {
        label: `${this.M}importBtn`,
        isMain: true,
        onClick: (ctx) => {
          ctx.validateForm().then(() => {
            this.props.setLoader(true)
            const body = {
              name: ctx.state.csvfile[0].name,
              doc: true,
              data: ctx.state.csvfile[0].value
            }

            _axios
              .post(`${this.props.uploadModuleName || this.props.moduleName}/importAttach`, body)
              .then(r => {
                if (r.status === 0) {
                  this.toggle()
                  this.props.ctx.getData()
                }
                NotificationManager[r.status >= 0 ? 'success' : 'error'](r.msg, r.status >= 0 ? '' : 'Opps', 5000, null, null, 'outline')
                this.props.setLoader(false)
              }).catch(e => {
                console.log(e)
                this.props.setLoader(false)
              })
          })
          .catch(e => { /* console.log(e) */ })
        }
      }
    ]

    this.setState({formFields: fields, formButtons: buttons})
  }

  toggle = () => {
    this.setState(prevState => ({
      modal: !prevState.modal
    }))
  }

  render() {
    const {locale} = this.props
    const L = AppLocale[locale].messages
    return (
      <div>
        {!this.props.hideButton && <Button type="button" color="primary" size="sm" className="mr-2" onClick={() => {this.toggle()}}>
          <i className="simple-icon-arrow-up-circle"></i> {L[`${this.M}importSyncMenu`]?? ""}
        </Button>}
        
        <CustomModal
          isOpen={this.state.modal}
          toggle={this.toggle}
          wrapClassName={"modal-right"}
          backdrop={'static'}
        >
          <ModalHeader toggle={this.toggle}>{L[`${this.M}importSyncMenu`]?? ""}</ModalHeader>
          <ModalBody className="p-0">
            {this.state.modal && <FormSmart
              fields={this.state.formFields}
              buttons={this.state.formButtons}
            />}
          </ModalBody>
        </CustomModal>
      </div>
    )
  }
}

const mapStateToProps = ({ settings }) => {
  const { locale } = settings
  return { locale }
}

export default connect(mapStateToProps, { setLoader })(ImportTo)